// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + ".80d2b0808c5f81782a0a071d042c2ff7.js";
};